import { render, staticRenderFns } from "./ContainersTab.vue?vue&type=template&id=7a4b875a"
import script from "./ContainersTab.vue?vue&type=script&lang=js"
export * from "./ContainersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports